import React from "react";
import { DeviceBreakpoint } from "../../App";
import "../../styles/components/layout/HeaderBar.css";

interface HeaderBarProps {
  title: string;
  showPreview: boolean;
  setShowPreview: (value: boolean) => void;
  onExport: () => void;
  deviceBreakpoints: DeviceBreakpoint[];
  currentBreakpoint: DeviceBreakpoint;
  onBreakpointChange: (breakpoint: DeviceBreakpoint) => void;
  onOpenPreviewInNewWindow?: () => void; // Added new prop
}

export const HeaderBar: React.FC<HeaderBarProps> = ({
  title,
  showPreview,
  setShowPreview,
  onExport,
  deviceBreakpoints,
  currentBreakpoint,
  onBreakpointChange,
  onOpenPreviewInNewWindow,
}) => {
  return (
    <div className="editor-header">
      <h1>{title}</h1>

      <div className="device-breakpoints">
        {deviceBreakpoints.map((breakpoint) => (
          <button
            key={breakpoint.name}
            className={`device-button ${
              currentBreakpoint.name === breakpoint.name ? "active" : ""
            }`}
            onClick={() => onBreakpointChange(breakpoint)}
            title={`${breakpoint.name} (${breakpoint.width})`}
          >
            <span className="device-icon">{breakpoint.icon}</span>
            <span className="device-name">{breakpoint.name}</span>
          </button>
        ))}
      </div>

      <div className="editor-actions">
        <button
          className={`preview-toggle ${showPreview ? "active" : ""}`}
          onClick={() => setShowPreview(!showPreview)}
        >
          {showPreview ? "📝 Edit Mode" : "👁️ Preview Mode"}
        </button>
        {onOpenPreviewInNewWindow && (
          <button
            className="preview-new-window"
            onClick={onOpenPreviewInNewWindow}
          >
            🔄 Preview in New Tab
          </button>
        )}
        <button className="export-json" onClick={onExport}>
          💾 Export JSON
        </button>
      </div>
    </div>
  );
};
